/*
  소개글 HTML 후처리 모음.
  에디터 인스턴스가 필요 없는 순수 문자열 변환만 둔다.
  (react-quill 을 끌고 오지 않아야 읽기 전용 뷰에서도 가볍게 쓸 수 있다)
 */

const TABLE_TEMPORARY_SELECTOR = 'temporary.ql-table-temporary';

const isIgnorableNode = (node: ChildNode) => {
  if (node.nodeName === 'BR') {
    return true;
  }

  return node.nodeType === Node.TEXT_NODE && !node.textContent?.trim();
};

/*
  quill-table-better 는 표의 width/class 를 델타에 실어 나르려고 표 앞에
  <temporary class="ql-table-temporary"> 라는 빈 줄을 만들고,
  그 줄을 .ql-table-temporary { display: none } 으로 숨긴다.
  높이가 0일 뿐 Quill 문서상으로는 멀쩡한 한 줄이라 커서가 올라갈 수 있어서,
  표 바로 위에서 이미지를 넣으면 이 보이지 않는 줄에 갇혀 소개글에서 통째로 사라진다.

  갇힌 내용만 바로 앞 문단으로 꺼내고, temporary 엘리먼트와 속성은
  표 메타데이터라 그대로 둔다.
 */
export const normalizeTableTemporary = (html: string): string => {
  if (!html || !html.includes('ql-table-temporary')) {
    return html;
  }

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const temporaries = doc.querySelectorAll(TABLE_TEMPORARY_SELECTOR);

  if (!temporaries.length) {
    return html;
  }

  let isChanged = false;

  temporaries.forEach(temporary => {
    const trapped = Array.from(temporary.childNodes).filter(
      node => !isIgnorableNode(node),
    );

    if (!trapped.length) {
      return;
    }

    const paragraph = doc.createElement('p');
    trapped.forEach(node => paragraph.appendChild(node));

    temporary.parentNode?.insertBefore(paragraph, temporary);
    temporary.innerHTML = '<br>';

    isChanged = true;
  });

  return isChanged ? doc.body.innerHTML : html;
};
